import React from 'react'

//
import { MicroCopyContext } from '../components/page-wrapper'

export const getMicroCopy = ({ key, tokens = {}, fallback = null, data = {} }) => {
  // Return the key if no data exists and no fallback is provided
  if (!data[key] && !fallback) {
    return key
  }

  // Return the fallback if no data exists for the key
  if (!data[key] && fallback) {
    return fallback
  }

  const value = data[key]

  // If there are no tokens to replace, return the value directly
  if (!value || Object.keys(tokens).length === 0) {
    return value || fallback
  }

  // Efficient token replacement using `replace` method
  const result = Object.keys(tokens).reduce((acc, tokenKey) => {
    const tokenPattern = new RegExp(`{${tokenKey}}`, 'g') // Create token pattern for each token
    return acc.replace(tokenPattern, tokens[tokenKey]) // Replace each token with its corresponding value
  }, value)

  return result || fallback
}

export const MicroCopy = ({ name, tokens, fallback }) => {
  const data = React.useContext(MicroCopyContext) || {}
  const value = getMicroCopy({ key: name, tokens, fallback, data })

  return <React.Fragment>{value}</React.Fragment>
}
